@if (this.showConfetti()) {
  <app-confetti/>
}

<div
  class="content"
  [class.fullscreen]="tabBarComponent.hideTabBar()"
  [@routeAnimations]="outlet?.activatedRouteData?.['animation']"
>
  <div
    class="clickable-media"
    [dwallClickableMedia]="['/main', 'special-offer']"
  ></div>

  <core-background-player
    class="background-player"
  />

  <router-outlet #outlet="outlet"/>
</div>

<app-tab-bar #tabBarComponent/>
